/*
  Fella Golf: "Notify me" formulier op de productpagina.
  Vervangt assets/product-unavailable-form.js van het thema.
  Verzoek gaat naar Klaviyo als Back in Stock aanmelding (per maat); met het
  (standaard uitgeschakelde) vinkje wordt de klant ook aangemeld voor de Klaviyo Email List.
  Lukt Klaviyo niet, dan gaat het verzoek via het Shopify contactformulier naar de inbox.
*/
var KLAVIYO_PUBLIC_KEY = 'UbqDrU';
var KLAVIYO_LIST_ID = 'V5vXbr'; // Email List
var KLAVIYO_REVISION = '2024-10-15';

function klaviyoPost(path, payload) {
  return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + KLAVIYO_PUBLIC_KEY, {
    method: 'POST',
    headers: { 'Content-Type': 'application/vnd.api+json', 'revision': KLAVIYO_REVISION },
    body: JSON.stringify(payload)
  }).then(function (res) {
    if (!res.ok) throw new Error('Klaviyo ' + res.status);
    return res;
  });
}

function klaviyoBackInStock(email, variantId) {
  if (!variantId) return Promise.reject(new Error('no variant'));
  return klaviyoPost('back-in-stock-subscriptions', {
    data: {
      type: 'back-in-stock-subscription',
      attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
      relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
    }
  });
}

function klaviyoSubscribe(email) {
  return klaviyoPost('subscriptions', {
    data: {
      type: 'subscription',
      attributes: {
        custom_source: 'Notify me product page',
        profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
      },
      relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
    }
  });
}

async function contactFallback(email, message) {
  var root = (window.theme && window.theme.urls && window.theme.urls.root) || '';
  var res = await fetch(root + '/contact', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ form_type: 'contact', contact: { email: email, message: message } })
  });
  if (!res.ok) throw new Error(res.statusText);
  return res;
}

class FgProductUnavailableForm extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.product-unavailable--input');
    this.formValue = this.querySelector('.product-unavailable--value');
    this.submit = this.querySelector('.product-unavailable--submit');
    this.consent = this.querySelector('.fg-notify-pdp--consent-input');
    this.msg = this.querySelector('.fg-notify-pdp--msg');
    this.variantId = this.dataset.variantId || '';
    this.variantTitle = this.dataset.variantTitle || '';
    this.productTitle = this.dataset.productTitle || '';

    this.submit.addEventListener('click', (e) => { e.preventDefault(); this.send(); });
    this.input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); this.send(); } });

    var evt = 'theme:product:' + this.dataset.id + ':variantChanged';
    var handler = (e) => {
      var v = e && e.detail && e.detail.variant;
      this.setAttribute('aria-hidden', !v || v.available ? 'true' : 'false');
      if (v) {
        this.variantId = String(v.id);
        this.variantTitle = v.title || '';
        if (this.formValue) this.formValue.value = 'Please notify me when this is back in stock: ' + (v.name || this.productTitle);
      }
      this.setMsg('');
    };
    if (typeof window.on === 'function') { window.on(evt, handler); } else { window.addEventListener(evt, handler); }
  }

  setMsg(text, type) {
    if (!this.msg) return;
    this.msg.textContent = text || '';
    this.msg.setAttribute('data-type', type || '');
  }

  async send() {
    var email = (this.input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { this.setMsg('Please enter a valid email address', 'error'); return; }
    var wantsMarketing = this.consent && this.consent.checked;

    this.setAttribute('aria-busy', 'true');
    this.submit.setAttribute('disabled', 'true');
    this.setMsg('');

    var ok = false;
    try {
      await klaviyoBackInStock(email, this.variantId);
      ok = true;
    } catch (err) {
      try {
        await contactFallback(email, this.formValue ? this.formValue.value : this.productTitle);
        ok = true;
      } catch (err2) { ok = false; }
    }
    if (wantsMarketing) { try { await klaviyoSubscribe(email); } catch (err3) {} }

    this.setAttribute('aria-busy', 'false');
    this.submit.removeAttribute('disabled');
    if (ok) {
      this.input.value = '';
      if (this.consent) this.consent.checked = false;
      this.setMsg("Thanks! We'll email you as soon as it's back in stock.", 'success');
    } else {
      this.setMsg('Something went wrong. Please try again.', 'error');
    }
  }
}

if (!customElements.get('product-unavailable-root')) {
  customElements.define('product-unavailable-root', FgProductUnavailableForm);
}
